<template>
  <div>
    <el-dialog title="考试配置" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <list-exam-vue :form="form" />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listExamVue from './common/exam.vue'
import courseSubjectApi from '@/api/course/courseSubject'
function initFormBean() {
  const formBean = {
    isExam: null,
    topicClassificationId: null,
    achievementScore: null,
    examCredits: null,
    examNum: null,
    examRules: null,
    isLookSolution: null,
    examOrder: null,
    examDuration: null,

  }
  return formBean
}

export default {
  components: { listExamVue },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        isExam: [{ required: true, message: '请选择是否考试', trigger: 'change' }],
        topicClassificationId: [{ required: true, message: '请选择试卷题目', trigger: 'change' }],
        achievementScore: [{ required: true, message: '请输入考试达标分数', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examCredits: [{ required: true, message: '请输入考试完成后获得的学分', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examNum: [{ required: true, message: '请输入考试题数', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examRules: [{ required: true, message: '请选择考试规则', trigger: 'change' }],
        examSingleScore: [{ required: true, message: '请输入每道题得分', trigger: 'blur' },
        { pattern: /^\d+(\.\d{1,2})?$/, message: '必须为数字值', trigger: 'blur' }],
        isLookSolution: [{ required: true, message: '请选择是否能看答案', trigger: 'change' }],
        examOrder: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examDuration: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
      },
      rowItem: null
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate(row) {
      this.resetForm()
      this.getDetails(row)
    },
    getDetails(row) {
      courseSubjectApi.fetchById(row.id).then((res) => {
        this.form = res.data;
        this.calcEditData()
        this.formVisible = true
      })
    },
    calcEditData() {
      let { courseClassificationVOList } = this.form;
      //课程分类
      let categArr = []
      courseClassificationVOList && courseClassificationVOList.forEach(itt => {
        let arr = [itt.id]
        if (itt.courseClassificationVO) {
          arr.push(itt.courseClassificationVO.id)
          if (itt.courseClassificationVO.courseClassificationVO) {
            arr.push(itt.courseClassificationVO.courseClassificationVO.id)
          }
        }
        categArr.push(arr)
      })
      this.$set(this.form, 'courseClassificationList', categArr);
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      let arr = [];
      // //freeLearningAuth 免费学习权限 paidLearningAuth 收费学习权限  lookCreditAuth 查看学习权限
      if (params.freeLearningAuth && params.freeLearningAuth.length > 0) {
        params.freeLearningAuth.forEach(item => {
          let find = arr.find(it => it.levelSource === item.levelSource && it.authType === 1)
          if (find) find.levelIds.push(item.levelId)
          else arr.push({ authType: 1, levelSource: item.levelSource, levelIds: [item.levelId] })
        })
      }
      if (params.paidLearningAuth && params.paidLearningAuth.length > 0) {
        params.paidLearningAuth.forEach(item => {
          let find = arr.find(it => it.levelSource === item.levelSource && it.authType === 2)
          if (find) find.levelIds.push(item.levelId)
          else arr.push({ authType: 2, levelSource: item.levelSource, levelIds: [item.levelId] })
        })
      }
      if (params.lookCreditAuth && params.lookCreditAuth.length > 0) {
        params.lookCreditAuth.forEach(item => {
          let find = arr.find(it => it.levelSource === item.levelSource && it.authType === 3)
          if (find) find.levelIds.push(item.levelId)
          else arr.push({ authType: 3, levelSource: item.levelSource, levelIds: [item.levelId] })
        })
      }
      arr.forEach(item => {
        item.levelIds = item.levelIds.toString()
      })
      params.authData = arr
      return params
    },

    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          params.authData = JSON.stringify(params.authData)
          params.courseClassificationList = params.courseClassificationList.map(subArray => subArray.at(-1));
          this.submitGoods(params)
        }
      });
    },
    submitGoods(params) {
      delete params.studyAuth
      if (params.id) {
        delete params.freeLearningAuth
        delete params.lookCreditAuth
        delete params.paidLearningAuth
        delete params.courseClassificationVOList
        delete params.courseSubjectRepairPlanList
        delete params.courseSubjectVideoList
        delete params.courseSubjectWaresList
      }
      params.collectNum = +params.collectNum || 0
      params.examDuration = +params.examDuration || 0
      params.examNum = +params.examNum || 0
      params.examOrder = +params.examOrder || 0
      params.forwardNum = +params.forwardNum || 0
      params.likeNum = +params.likeNum || 0
      params.playNum = +params.playNum || 0
      params.examRules = +params.examRules || 0
      courseSubjectApi.update(params).then((data) => {
        this.postCallback(data)
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
